module.exports = __webpack_public_path__ + "img/404.fe74c06d.svg";